import _get from 'lodash/get';

/**
 * Video Intelligence (PCS-10650) — same shape as ArtificialIntelligenceTab.hasVideoAI
 * plus subscriptionFeatures.videoAnalyze (required by /analyzeVideo).
 */
export default function isVideoAiEnabled(user) {
  if (!user) return false;

  return Boolean(
    _get(user, 'subscriptionFeatures.videoAnalyze', false)
    || _get(user, 'team.featureFlags.videoAnalyzePlanOverride', false)
    || _get(user, 'addonsFeatures.videoIntelligence.id')
    || _get(user, 'addonsFeatures.aiKit.id'),
  );
}
